export enum SnackbarMessage {
    ADD = 'Added Successfully',
    EDIT ='Edited Successfully',
    DELETE = 'Deleted Successfully',
}